import { render, staticRenderFns } from "./friendList.vue?vue&type=template&id=53e78813&scoped=true"
import script from "./friendList.vue?vue&type=script&lang=js"
export * from "./friendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e78813",
  null
  
)

export default component.exports